import { render, staticRenderFns } from "./AmazonCustomExport.vue?vue&type=template&id=0e1dfb84&scoped=true&"
import script from "./AmazonCustomExport.vue?vue&type=script&lang=js&"
export * from "./AmazonCustomExport.vue?vue&type=script&lang=js&"
import style0 from "./AmazonCustomExport.vue?vue&type=style&index=0&id=0e1dfb84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1dfb84",
  null
  
)

export default component.exports